import { boletasTypes } from "./types";
import authAxios from "../config/authAxios";
import { avisoCargando, avisoError } from "../view/components/AvisosMensajes/MensajesSwalf";
import Swal from "sweetalert2/src/sweetalert2";
import { updateStateModalLarge } from "./modalActions";

export const listarBoletas = (usuario) => async dispatch => {
  dispatch({ type: boletasTypes.OBTENER_BOLETAS });
  try {
    const res = await authAxios.get(
      `/admin/listarBoletasDePago/${usuario.dni}/${usuario.id_tp_nivel_usuario}`
    );
    dispatch({ payload: res.data.boletas, type: boletasTypes.OBTENER_BOLETAS_EXITO });
  } catch (error) {
    console.log(error);
    avisoError('Hubo un error al cargar las boletas');
  }
};

export const subirBoletas = (datos, archivos, usuario) => async dispatch => {
  const file = new FormData();
  archivos.forEach(element => file.append('archivos[]', element));
  file.append('periodo', datos.periodo);
  file.append('mes', datos.mes);

  try {
    avisoCargando('Subiendo archivos, espere por favor...');
    const subida = await authAxios.post(
      '/admin/subirBoletas', file,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );

    // Cerrar modal y refrescar lista
    dispatch(updateStateModalLarge());
    dispatch(listarBoletas(usuario));

    // Guardar resultado en Redux para mostrarlo en la vista principal
    dispatch({
      type: boletasTypes.SUBIR_BOLETAS_EXITO,
      payload: {
        detectadas:  subida.data.detectadas  || 0,
        asignadas:   subida.data.asignadas   || subida.data.archivos_subidos || 0,
        sin_asignar: subida.data.sin_asignar || 0,
        erroneas:    subida.data.erroneas    || 0,
        detalle:     subida.data.detalle     || [],
        archivos_erroneos: subida.data.archivos_erroneos || [],
      }
    });

  } catch (error) {
    console.log(error);
    avisoError('Hubo un error al subir los archivos');
  }
};

export const limpiarResultadoBoletas = () => ({
  type: boletasTypes.LIMPIAR_RESULTADO_BOLETAS,
});

export const eliminarBoleta = (id) => async dispatch => {
  const swal = Swal.mixin({});
  swal.fire({
    title: "¿Estás seguro?",
    text: "Se eliminará el registro y el archivo",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Sí, eliminar",
    cancelButtonText: "Cancelar",
    reverseButtons: true,
    showLoaderOnConfirm: true,
    preConfirm: async () => {
      try {
        const res = await authAxios.delete(`/admin/eliminarBoleta/${id}`);
        dispatch({ payload: res.data.boletas, type: boletasTypes.OBTENER_BOLETAS_EXITO });
        return true;
      } catch (error) {
        avisoError('Hubo un error al eliminar el documento');
      }
    },
    allowOutsideClick: () => !Swal.isLoading()
  }).then(result => {
    if (result.value === true) {
      swal.fire("Eliminado", "Documento eliminado correctamente", "success");
    }
  });
};
